import { Component, OnInit } from '@angular/core';
import { TenderService } from './../../services/tender.service';

@Component({
  selector: 'app-current-tenders',
  templateUrl: './current-tenders.component.html'
})
export class CurrentTendersComponent implements OnInit {

  constructor(private tenderService: TenderService) { }

  page = 1;
  pageSize = 12;
  collectionSize = 0;

  AllTender: any[] = [];
  TenderCategories$: any[] = [];
  TenderLocations$: any[] = [];
  TenderList$: any[] = [];
  FeaturedArticle$: any;

  selectedCategory$: number = 0;
  selectedLocation$: number = 0;

  ngOnInit() {
  }

  getTenderCategoriesList() {
    this.tenderService.getTenderCategoriesList().subscribe((response) => {
      this.TenderCategories$ = response as any[];
      this.getTenderLocationsList();
    }, (error) => {
      console.log(error);
    });
  }

  getTenderLocationsList() {
    this.tenderService.getTenderLocationsList().subscribe((response) => {
      this.TenderLocations$ = response as any[];
      this.getTenderList();
    }, (error) => {
      console.log(error);
    });
  }

  getTenderList() {
    this.tenderService.getTenderList(true).subscribe((response) => {

      response.forEach((val, idx) => {
        val.websiteListingStartDate = val.websiteListingStartDate.toString().substring(0, 10);
        val.websiteListingEndDate = val.websiteListingEndDate.toString().substring(0, 10);

        val.category = this.TenderCategories$.find(x => x.id == val.categoryId).title;
        val.location = this.TenderLocations$.find(x => x.id == val.locationId).title;
      });

      this.AllTender = response as any[];
      this.TenderList$ = this.AllTender;
      this.collectionSize = this.TenderList$.length;

      return response
        .map((gal, i) => ({ id: i + 1, ...gal }))
        .slice((this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);
    }, (error) => {
      console.log(error);
    });
    return null;
  }

  ngAfterContentInit() {
    this.getTenderCategoriesList();
  }

  applyFilters() {

    this.TenderList$ = this.AllTender;

    var result = [];

    if (this.selectedCategory$ > 0 && this.selectedLocation$ > 0) {
      const filteredData = this.AllTender.filter(x => x.categoryId == this.selectedCategory$ && x.locationId == this.selectedLocation$);
      result.push(filteredData);
    }
    else if (this.selectedCategory$ > 0) {
      //category search
      const filteredData = this.AllTender.filter(x => x.categoryId == this.selectedCategory$);
      result.push(filteredData);
    }
    else if (this.selectedLocation$ > 0) {
      //location search
      const filteredData = this.AllTender.filter(x => x.locationId == this.selectedLocation$);
      result.push(filteredData);
    }

    if (result.length > 0) {
      var final = [];

      //combine result into one final array
      result.forEach(function (val, ind, arr) {
        final.push(val);
      });

      //remove duplicates from final array
      var unique = final.filter(function (elem, index, self) {
        return index == self.indexOf(elem);
      });

      this.TenderList$ = unique[0];
    }

    if (this.TenderList$.length == 0) {
      this.TenderList$ = null;
      this.collectionSize = 0;
    }
    else {
      this.collectionSize = this.TenderList$.length;
    }

  }

  resetSearch() {
    this.selectedCategory$ = 0;
    this.selectedLocation$ = 0;
    this.TenderList$ = this.AllTender;
    this.collectionSize = this.TenderList$.length;
  }

}
